import React, { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getCategoryList,
  getProductList,
  getProductTypeList,
} from "../../Admin/adminSlice";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
import { paymentOptions } from "../../../Utils/dataConstant";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { getProductWiseRevenue } from "../cxoSlice";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const ProductWiseAnalysis = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productList, setProductList] = useState<any>([]);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss")
  );
  const [paymentType, setPaymentType] = useState<any>("");
  const [productAnalysisList, setProducteAnalysisList] = useState<any>([]);
  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, [dispatch]);

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
    const postData = {
      productTypeId: productType?._id,
      categoryId: value?._id,
    };
    dispatch(
      getProductList({
        params: postData,
        callback: (res: any) => {
          setProductList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
  };

  const onchangeProduct = (value: any) => {
    setProduct(value);
  };
  const onchangePaymentType = (value: any) => {
    setPaymentType(value);
  };

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postdata = {
      startDate: startDate,
      endDate: endDate,
      categoryId: category?._id,
      productTypeId: productType?._id,
    };
    dispatch(getProductWiseRevenue({
      params: postdata,
      callback: (res: any) => {
        setProducteAnalysisList(res?.data);
        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
      },
      errorCallback: (error: any) => {
        dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        console.error(error);
      }
    }))
  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"ALL PRODUCT WISE ANALYSIS"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DateTimePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DateTimePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product List"} />
                <DropdownWithClear
                  labelName={"Select Product List "}
                  setInputText={(value: any) => onchangeProduct(value)}
                  options={productList}
                  value={product}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Payment Type"} />
                <DropdownWithClear
                  labelName={"Select Payment Type "}
                  setInputText={(value: any) => onchangePaymentType(value)}
                  options={paymentOptions}
                  value={paymentType}
                />
              </div>
              <div className="d-flex justify-content-center mt-3">
                <div className="col-2 pt-2">
                  <Submitbtn name={"Submit"} disabled={validations()} />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="bxshadow p-2 borderRadius">
          <div className="admin-table table-responsive">
            <table className="table table-striped table-hover align-middle text-md-start text-center">
              <thead>
                <tr>
                  <th>S.N</th>
                  <th>Product Type</th>
                  <th>Product Category</th>
                  <th>Product Name</th>
                  <th>Actual Amount</th>
                  <th>GST Amount</th>
                  <th>Total Amount</th>
                  <th>Product Contribution</th>
                  <th>Category Contribution</th>
                  <th>Product Type Contribution</th>
                </tr>
              </thead>
              <tbody className="border border-2">
                {productAnalysisList?.length > 0 ?
                  productAnalysisList.map((productType: any, typeIndex: number) => (
                    <React.Fragment key={typeIndex}>
                      {productType.categories.map((category: any, catIndex: number) => (
                        <React.Fragment key={catIndex}>
                          {category.products.map((product: any, prodIndex: number) => (
                            <tr className="border border-2" key={prodIndex}>
                              {catIndex === 0 && prodIndex === 0 && (
                                <td className="border border-2" rowSpan={productType.categories.reduce((acc: any, curr: any) => acc + curr.products.length, 0)}>
                                  {typeIndex + 1}
                                </td>
                              )}
                              {catIndex === 0 && prodIndex === 0 && (
                                <td className="border border-2" rowSpan={productType.categories.reduce((acc: any, curr: any) => acc + curr.products.length, 0)}>
                                  {productType.productTypeName}
                                </td>
                              )}
                              {prodIndex === 0 && (
                                <td className="border border-2" rowSpan={category.products.length}>{category.categoryName}</td>
                              )}
                              <td className="border border-2">{product.productName}</td>
                              <td className="border border-2">{product.totalWithoutGstAmount}</td>
                              <td className="border border-2">{product.totalIgstAmount}</td>
                              <td className="border border-2">{product.totalOfferPrice}</td>
                              <td className="border border-2">{product.productContribution}</td>
                              {prodIndex === 0 && (
                                <td className="border border-2" rowSpan={category.products.length}>{category.categoryContribution}</td>
                              )}
                              {catIndex === 0 && prodIndex === 0 && (
                                <td className="border border-2" rowSpan={productType.categories.reduce((acc: any, curr: any) => acc + curr.products.length, 0)}>
                                  {productType.productTypeContribution}
                                </td>
                              )}
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))
                  :
                  <tr>
                    <td>No Result Found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ProductWiseAnalysis;
